module.exports = __webpack_public_path__ + "static/media/google_icon.14137f89.svg";